import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cutlery, Truck, Bag, NavArrowDown } from 'iconoir-react';
import './ModoEntregaSelector.css';

/**
 * Seletor dropdown para escolher modo: Ver Cardápio, Delivery ou Balcão
 */
const ModoEntregaSelector = ({ isDelivery, isBalcao, loja }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef(null);

  // Verificar configurações da loja
  const temDelivery = loja?.configuracoes?.b_delivery === 1;
  const temBalcao = loja?.configuracoes?.b_balcao === 1;

  // Determinar modo atual
  const getModoAtual = () => {
    if (isDelivery) return 'delivery';
    if (isBalcao) return 'balcao';
    return 'cardapio';
  };

  const modoAtual = getModoAtual();

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (modo) => {
    setIsOpen(false);
    if (modo === modoAtual) return;
    
    switch (modo) {
      case 'cardapio':
        navigate('/cardapio', { replace: true });
        break;
      case 'delivery':
        navigate('/delivery', { replace: true });
        break;
      case 'balcao':
        navigate('/balcao', { replace: true });
        break;
      default:
        break;
    }
  };

  const getLabel = (modo) => {
    switch (modo) {
      case 'cardapio':
        return 'Ver Menu';
      case 'delivery':
        return 'Pedir Delivery';
      case 'balcao':
        return 'Pedir no Balcão';
      default:
        return '';
    }
  };

  const getIcon = (modo) => {
    switch (modo) {
      case 'cardapio':
        return <Cutlery width={18} height={18} />;
      case 'delivery':
        return <Truck width={18} height={18} />;
      case 'balcao':
        return <Bag width={18} height={18} />;
      default:
        return null;
    }
  };

  // Construir lista de opções disponíveis
  const opcoes = [
    { modo: 'cardapio', disponivel: true },
    { modo: 'delivery', disponivel: temDelivery },
    { modo: 'balcao', disponivel: temBalcao }
  ].filter(op => op.disponivel);

  // Se só tem uma opção, não mostrar o seletor
  if (opcoes.length <= 1) {
    return null;
  }

  return (
    <div className="modo-entrega-container" ref={selectorRef}>
      <span className="modo-entrega-label">Modalidade:</span>
      <div className="modo-entrega-dropdown">
        <button 
          className="modo-entrega-trigger"
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          <div className="modo-entrega-selected">
            {getIcon(modoAtual)}
            <span>{getLabel(modoAtual)}</span>
          </div>
          <NavArrowDown 
            width={16} 
            height={16} 
            className={`modo-entrega-arrow ${isOpen ? 'open' : ''}`}
          />
        </button>

        {isOpen && (
          <div className="modo-entrega-options">
            {opcoes.map(({ modo }) => (
              <button
                key={modo}
                className={`modo-entrega-option ${modoAtual === modo ? 'active' : ''}`}
                onClick={() => handleSelect(modo)}
                type="button"
              >
                {getIcon(modo)}
                <span>{getLabel(modo)}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModoEntregaSelector;
